export default __webpack_public_path__ + "static/media/about-us-icon-fashion.7d99a5d7.png";